export default {
  no_mobile_app: 'Sin app móvil configurada',
  mobile_app_not_live: 'App móvil no activa',
};
